import React from 'react';
import SecuritySimple from './SecuritySimple';

const Security: React.FC = () => {
  return <SecuritySimple />;
};

export default Security;
